import { render, staticRenderFns } from "./ChangeUnitDetails.vue?vue&type=template&id=3b587527&"
import script from "./ChangeUnitDetails.vue?vue&type=script&lang=js&"
export * from "./ChangeUnitDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports